import SensorsIcon from "@mui/icons-material/Sensors";
import SensorsOffIcon from "@mui/icons-material/SensorsOff";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import {
  selectTrainingType,
  TrainingType,
} from "../../app/slices/TrainingSlice";
import { selectIsConnectedToWebSocket } from "../../app/slices/WebSocketSlice";
import { useCreatorWebSocketConnector } from "../send_to_unity/CreatorWebSocketConnector";

export default function TrainingActionbarConnectButton() {
  const { connect, disconnect } = useCreatorWebSocketConnector();
  const isConnected = useSelector(selectIsConnectedToWebSocket);
  const trainingType = useSelector(selectTrainingType);

  if (trainingType !== TrainingType.Training3D) return null;

  const onClick = () => {
    if (isConnected) {
      disconnect();
    } else {
      connect();
    }
  };

  const accentColor = "var(--pi-key-green)";

  const Icon = isConnected ? SensorsIcon : SensorsOffIcon;

  return (
    <Button
      variant="piBlueOutlined"
      size="small"
      onClick={onClick}
      aria-label={isConnected ? "Disconnect" : "Connect"}
      title={isConnected ? "Connected" : "Connect"}
      sx={{
        borderRadius: 9999,
        minWidth: 32,
        width: 32,
        height: 32,
        padding: 0,
        color: accentColor,
        borderColor: accentColor,
        background: isConnected
          ? `color-mix(in srgb, ${accentColor} 18%, transparent)`
          : "transparent",
        transition:
          "background 200ms ease, color 200ms ease, border-color 200ms ease",
        "&:hover": {
          background: accentColor,
          color: "white",
          borderColor: accentColor,
        },
      }}
    >
      <Icon sx={{ fontSize: 18 }} />
    </Button>
  );
}
